import Select from "react-select";
import makeAnimated from "react-select/animated";
import React, { useState, useEffect } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import swal from "sweetalert";
import { toast } from "react-toastify";

import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import bookclosurecss from "./../../css/bookclosure.module.css";
import Modal from "./../../elements/Modal";
import CustomDropdownIndicator from "./../../elements/CustomDropdownIndicator";
import InputGroup from "./../../elements/InputGroup";
import { ReqFieldLabel } from "./../../components/mis";
import { Button } from "./../../elements/Button";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";
import { customStyles } from "../../../Bookclosure/Components/AddTaskModal";
import { editCommentApiHandler } from "../../../Bookclosure/Services/ApiHandler";
import { isInputDisabled } from "../../../utils/taskAccess";

const EditCommentModal = ({
  setEditCommentModal,
  taskId,
  assignOptions,
  setCommentsList,
  taskComment,
  setTaskComment,
  editComment,
  taskDetails,
  userData
}) => {
  const animatedComponents = makeAnimated();
  const [comment, setComment] = useState(editComment?.text || null);

  console.log("editComment",editComment);
  

  const [assignee, setAssignee] = useState(
    editComment?.assigneeData
      ? {
          label: editComment?.assigneeData?.name,
          value: editComment?.assigneeData?._id,
        }
      : null
  );
  const [dueDate, setDueDate] = useState(
    editComment?.dueDate ? dayjs(editComment?.dueDate).format("DD-MM-YYYY") : null
  );
  const [tag, setTag] = useState(editComment?.tags || null);

  const updateComment = () => {
    if (!taskId) {
      // toast.warning("Please Save The Task.");
      swal("Please Save The Task.",'warning');
      return;
    }
    const payload = {
      taskID:taskId,
      commentID:editComment._id,
      text: comment,
      assignee: assignee.value,
      dueDate: dueDate,
    };
    console.log(payload);
    editCommentApiHandler(payload)
      .then((response) => {
        // console.log("response", response.data.comments);
        setCommentsList(response.data.comments.reverse());
        setEditCommentModal(false);
        setTaskComment("");
        // toast.success("Comment updated successfully.");
        swal("Success", "Comment updated successfully.", 'success')
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to updated Comment",
          "error"
        );
      });
  };
  return (
    <Modal
      title="Edit Comment"
      width="40%"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <CloseIcon
          onClick={() => {
            setEditCommentModal(false);
          }}
          className="clickable"
        />
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setEditCommentModal(false);
            }}
            label="Cancel"
          />
          <Button
            btnColor={buttoncss.primary}
            label="Update Comment"
            onClick={updateComment}
          />
        </>
      }
    >
      <div style={{ padding: "10px 30px" }}>
        <InputGroup
          class_="mb-0"
          label="Comment"
          req={true}
          inputs={[
            <>
              <textarea
                rows={4}
                placeholder="Enter Comment"
                name="comment"
                value={comment}
                onChange={(e) => {
                  setComment(e.target.value);
                }}
                disabled={isInputDisabled({ taskDetails, userData, userCheck: editComment.createdBy})}
              />
            </>,
          ]}
        />

        <InputGroup
          label="Add Assignee"
          req={true}
          inputs={[
            <>
              <Select
                placeholder="Select Assignee"
                name="assigneeId"
                value={assignee}
                onChange={(e) => {
                  setAssignee(e);
                }}
                options={assignOptions}
                className="w-100 mt-0"
                classNamePrefix="select"
                components={{
                  ...animatedComponents,
                  IndicatorSeparator: () => null,
                  DropdownIndicator: CustomDropdownIndicator,
                }}
                styles={customStyles}
                isDisabled={isInputDisabled({ taskDetails, userData, roles: ["Admin", "task-approver"], userCheck: editComment.assignee})}
              />
            </>,
          ]}
        />

        {/* <span className="input-label">
          <ReqFieldLabel />
          &nbsp;Add Assignee
        </span>
        <Select
          placeholder="Select Assignee"
          name="assigneeId"
          value={assignee}
          onChange={(e) => {
            setAssignee(e);
          }}
          options={assignOptions}
          className="w-100 mt-0 custom-bg-gray-300"
          classNamePrefix="select"
          components={animatedComponents}
          styles={customStyles}
        /> */}

        <InputGroup
          label="Due Date"
          inputs={[
            <>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                  <MobileDatePicker
                    disabled={isInputDisabled({ taskDetails, userData, roles: ["Admin", "task-approver"], userCheck: editComment.assignee})}
                    className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                    value={dueDate ? dayjs(dueDate) : null}
                    onChange={(value) => {
                      if (value && dayjs(value).isValid()) {
                        const formattedDate = dayjs(value).format("DD-MM-YYYY");
                        setDueDate(formattedDate);
                      } else {
                        setDueDate("");
                      }
                    }}
                    format="DD-MMM-YYYY"
                    slotProps={{
                      textField: {
                        InputProps: {
                          disableUnderline: true,
                        },
                        inputProps: {
                          placeholder: "DD-MM-YYYY",
                        },
                        sx: {
                          "& fieldset": {
                            border: "none",
                          },
                        },
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <span className="icon">
                <CalenderIcon className="vaMiddle" width={20} height={20} />
              </span>
            </>,
          ]}
        />

        <InputGroup
          class_="mb-2"
          label="Add Tags"
          inputs={[
            <>
              <input
                name="tag"
                value={tag}
                onChange={(e) => {
                  setTag(e.target.value);
                }}
                disabled={isInputDisabled({ taskDetails, userData, roles: ["Admin","approver","task-approver","task-preparer"], userCheck: editComment.assignee})}
              />
            </>,
          ]}
        />
      </div>
    </Modal>
  );
};

export default EditCommentModal;
